module.exports = __webpack_public_path__ + "img/ic-question-mark.84f640bd.svg";